import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';

const MultilingualFilterIcon = (props: any) => {
  const theme = useContext(ThemeContext);
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M11 15C12.8667 13.875 16.6 10.5 16.6 6M11 9.375C12.9985 11.5964 14.398 12.6658 18 13.875"
        stroke={theme.colors.neutrals.c400}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path d="M10 6H14M18 6H14M14 4V6" stroke={theme.colors.neutrals.c400} strokeWidth="1.5" strokeLinecap="round" />
      <path
        d="M0.32918 13.6646C0.143938 14.0351 0.294106 14.4856 0.66459 14.6708C1.03507 14.8561 1.48558 14.7059 1.67082 14.3354L0.32918 13.6646ZM5 6L5.67082 5.66459C5.54378 5.4105 5.28408 5.25 5 5.25C4.71592 5.25 4.45622 5.4105 4.32918 5.66459L5 6ZM8.32918 14.3354C8.51442 14.7059 8.96493 14.8561 9.33541 14.6708C9.70589 14.4856 9.85606 14.0351 9.67082 13.6646L8.32918 14.3354ZM2.14286 11.7143L1.47204 11.3789L2.14286 11.7143ZM7.85714 11.7143L8.52796 11.3789L7.85714 11.7143ZM1.67082 14.3354L2.81368 12.0497L1.47204 11.3789L0.32918 13.6646L1.67082 14.3354ZM2.81368 12.0497L5.67082 6.33541L4.32918 5.66459L1.47204 11.3789L2.81368 12.0497ZM4.32918 6.33541L7.18632 12.0497L8.52796 11.3789L5.67082 5.66459L4.32918 6.33541ZM7.18632 12.0497L8.32918 14.3354L9.67082 13.6646L8.52796 11.3789L7.18632 12.0497ZM2.14286 12.4643H7.85714V10.9643H2.14286V12.4643Z"
        fill={theme.colors.neutrals.c400}
        stroke="none"
      />
    </svg>
  );
};

export default MultilingualFilterIcon;
